<template>
  <div id="SectionSupport">
    <UIContainer>
      <SectionTitle class="SectionSupport__title">
        <template #title>
          Support at any stage of your sustainability journey
        </template>
      </SectionTitle>

      <img
        src="./images/support/support.avif"
        alt="Support"
        class="SectionSupport__image"
      />
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionSupport {
  background-color: $color-ui-brand-50;

  .SectionSupport__title {
    max-width: 48rem;
    text-align: center;
    margin: 0 auto 1rem;
  }

  .SectionSupport__image {
    width: 100%;
  }
}
</style>
